/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
import io from 'socket.io-client';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.io = io;
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';


// Create the socket connection lazily: only the live paired-session pages use `Echo`, so the
// homepage, dashboard and practice pages no longer open (and keep polling) a socket connection.
let echoInstance = null;
Object.defineProperty(window, 'Echo', {
    configurable: true,
    get() {
        if (!echoInstance) {
            echoInstance = new Echo({
                broadcaster: 'socket.io',
                host: window.location.origin,
                client: io,
                transports: ['websocket', 'polling'],
                withCredentials: true
            });
        }
        return echoInstance;
    },
});
